import React, { useEffect } from 'react'
import className from 'classnames/bind'

import style from './MyhouseCloseGuidePage.module.scss'

import MyhouseCloseHeader from '@Components/atoms/MyhouseCloseHeader'
import MyhouseCloseGuide from '@Components/atoms/MyhouseCloseGuide'
import BlindContent from '@Components/atoms/BlindContent'
import useModal from '@Hooks/myhouse/useModal'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import { landAxios } from '@Root/utils/landAxios'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK, NDS_PROTOCOL } from '@Root/contants/lcs'
import { lcsSend } from '@Helpers/lcs'

const cx = className.bind(style)

const MyhouseCloseGuidePage: React.FC = () => {
  const { open, modal, clean } = useModal()

  const myhouseWithdrawalHandler = (e: React.SyntheticEvent) => {
    handleNclick(NCLICK.MY_HOUSE.WITHDRAWAL.SHOW_POPUP, e)
    open(MODAL_TYPE.CLOSE_SERVICE, {
      nclickConfirm: NCLICK.MY_HOUSE.WITHDRAWAL.POPUP.WITHDRAWAL,
      nclickCancel: NCLICK.MY_HOUSE.WITHDRAWAL.POPUP.CANCEL,
    })
  }

  useEffect(() => {
    lcsSend(NDS_PROTOCOL.MY_HOUSE.HOME.WITHDRAWAL)
  }, [])

  useEffect(() => {
    if (modal.confirmModal === MODAL_TYPE.CLOSE_SERVICE) {
      clean()
      landAxios.post(`/myhouse/withdrawal`).then((res) => {
        if (document.referrer && document.referrer.includes('pay.naver.com')) {
          // TODO: 네이버 페이 쪽에서 레퍼러 추가 필요
          window.location.href = `${process.env.REACT_APP_NAVER_MYMONEY_URL}`
        } else {
          window.location.href = `${process.env.REACT_APP_SPACE_WEB_URL}`
        }
      })
    }
  }, [modal.confirmModal])

  return (
    <>
      <MyhouseCloseHeader />
      <section id="content" className={cx('content_myhouse', 'type_close')} role="main">
        <BlindContent />
        <div className={cx('myhouse_close_inner')}>
          <MyhouseCloseGuide />
        </div>
        <div className={cx('myhouse_close_service')}>
          <button type="button" className={cx('myhouse_close_button')} onClick={myhouseWithdrawalHandler}>
            서비스 해지
          </button>
        </div>
      </section>
    </>
  )
}

export default MyhouseCloseGuidePage
